import { INetwork, Network } from "relay-runtime";

import createMiddlewareStack from "@framework/relay/shared/createMiddlewareStack";
import { HydrationData } from "@framework/relay/shared/hydration";
import {
  GraphQLOperation,
  IncomingRequestContext,
} from "@framework/relay/shared/Middleware";

import createIsomorphicServerMiddlewareList from "./create-server-middleware-list";

/**
 * Creates a server network that is safe to import in files which are
 * isomorphic provided the code is only executed on the server.
 * Used by createIsomorphicQueryFetcher which is imported in _app and as a
 * result cannot contain server-only code despite the query fetching only
 * being executed on the server.
 */
export default function createIsomorphicServerNetwork({
  hydrationData,
  persisted,
  communityApiUrl,
  userAgent,
  bypassCache,
  fastlyDebugHeader,
  options = {},
  incomingRequestContext,
}: {
  hydrationData: HydrationData | null;
  persisted: Record<string, string>;
  communityApiUrl: string | null;
  userAgent?: string;
  bypassCache?: boolean;
  fastlyDebugHeader?: boolean;
  options?: {
    onHeaders?: (headers: Headers, operation: GraphQLOperation) => void;
  };
  incomingRequestContext?: IncomingRequestContext;
}): INetwork {
  const { WP_GRAPHQL_URL } = process.env;

  if (!WP_GRAPHQL_URL) {
    throw new Error("WP_GRAPHQL_URL is not defined");
  }
  const middleware = createIsomorphicServerMiddlewareList({
    hydrationData,
    persisted,
    userAgent,
    bypassCache,
    fastlyDebugHeader,
  });
  return Network.create(
    createMiddlewareStack({
      url: communityApiUrl || WP_GRAPHQL_URL,
      middleware,
      options,
      incomingRequestContext,
    }),
  );
}
